<ng-container *ngIf="control">
  <mat-form-field class="{{ additionalClass() }}" [floatLabel]="floatLabel() ? 'always' : 'auto'">
    <mat-label [ngClass]="{
      'text-red': control.invalid && (control.dirty || control.touched)
    }">{{ label() }}</mat-label>
    
    <input
      matInput
      type="text"
      [autocomplete]="autocomplete()"
      [formControl]="control"
      [mask]="maskComputed()"
      [thousandSeparator]="','"
      [prefix]="prefixComputed()"
      [dropSpecialCharacters]="true"
      [pattern]="patternComputed()"
      [attr.disabled]="disabled"
      [step]="stepComputed()"
      [min]="minComputed()"
      [max]="max()"
      [readonly]="readonly()"
      [placeholder]="placeholderComputed()"
      [ngClass]="{
        'text-center': alignment() === 'center',
        'text-left': alignment() === 'left',
        'text-right': alignment() === 'right'
      }"
    />
  
    <mat-hint align="start" *ngIf="startHint()">
      <strong>{{ startHint() }}</strong>
    </mat-hint>
    <mat-hint align="end" *ngIf="endHint()">
      <strong>{{ endHint() }}</strong>
    </mat-hint>

    <!-- A 'message' error is more specific, so show it alone rather than stacked under "Required" -->
    <mat-error *ngIf="showError && control?.hasError('required') && !control?.hasError('message')" [id]="''">Required</mat-error>
    <mat-error *ngIf="control?.hasError('pattern')">{{ patternErrorMessageComputed() }}</mat-error>
    <mat-error *ngIf="control?.hasError('min')" [id]="''">{{ minError() }}</mat-error>
    <mat-error *ngIf="control?.hasError('max')" [id]="''">{{ maxError() }}</mat-error>
    <mat-error *ngIf="control?.hasError('message')" [id]="''">{{ control.getError('message') }}</mat-error>
  </mat-form-field>
</ng-container>